import { useRef } from 'react';

import { IWalletTag } from '@entities/wallet-tags';
import { INewWalletResponse } from '@entities/wallets';
import { ITagOption, tagToOption, useAssignWalletTags } from '@features/wallets';
import { useModal } from '@shared/components/Modal';

import { NewWalletMID } from './NewWalletMID';

export const useWalletCreate = (refetch: () => void, initialTags: IWalletTag[] = []) => {
  const { openModal } = useModal();
  const { assignTags } = useAssignWalletTags();
  const tagsRef = useRef<ITagOption[]>(initialTags.map(tagToOption));

  const handleCreateWallet = (formData: FormData): FormData => {
    if (!formData.get('kind')) formData.delete('kind');
    return formData;
  };

  const handleSuccess = async (response: INewWalletResponse) => {
    if (tagsRef.current.length) {
      await assignTags(response.data.id, tagsRef.current);
    }

    openModal(
      <NewWalletMID
        parent_id={response.data.id}
        parent_name={response.data.name}
        refetch={refetch}
        shouldSubmitDefaultSettings={true}
      />,
    );
  };

  return { handleCreateWallet, handleSuccess, tagsRef };
};
